import { Box, Divider, Typography } from "@mui/material";
import { t } from "i18next";
import React from "react";
import { FeaturesList, FeaturesListItem } from "./PremiumAccountCard";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import theme from "../../styles/styleTheme";

const BasicAccountDetails = () => {
  return (
    <Box height={320}>
      <Box
        display={"flex"}
        justifyContent={"flex-start"}
        alignItems={"flex-start"}
        flexDirection={"column"}
      >
        <Typography
          variant="h3"
          marginBottom={5}
          color={theme.palette.grey[800]}
        >
          {t("profile.basic_account")}
        </Typography>
        <Typography
          color={theme.palette.grey[800]}
          fontSize={40}
          fontWeight={500}
        >
          {t("profile.basic_price")}
        </Typography>
        <Typography
          fontWeight={300}
          color={theme.palette.grey[500]}
          fontSize={20}
        >
          {t("profile.unlimited")}
        </Typography>
      </Box>
      <Divider sx={{ margin: "2rem 0" }} />
      <FeaturesList>
        <FeaturesListItem>
          <CloseRoundedIcon color="secondary" />
          <Typography variant="body1">{t("profile.feature1")}</Typography>
        </FeaturesListItem>
        <FeaturesListItem>
          <DoneRoundedIcon color="secondary" />
          <Typography variant="body1">{t("profile.feature2")}</Typography>
        </FeaturesListItem>
      </FeaturesList>
    </Box>
  );
};

export default BasicAccountDetails;
